import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { paidThroughInitialsForAdd, paidThroughInitialsForUpdate } from './interfaces/paidThroughClass';
import { addPaidThroughAsync, updatePaidThroughAsync,getAccountPaidThroughAsync, resetSelectedRecordObjectInState } from './paidThroughSlice';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';

const PaidThroughForm = (props: any) => {
    const {t} = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(paidThroughInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.paidThrough);
    const dispatch = useAppDispatch();
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [selectedOptionCurrecny, setSelectedOptionCurrency] = useState<{ [object: string]: any }>();
    const [SystemPaymentArray, SetSystemPaymentArray] = useState<any | ''>([]);
    const [currencyArray, SetCurrencyArray] = useState<any | ''>([]);

    const getSystemPaymentAccountTypeAsync = async () => {
        const response = await fetchAPI('api/V2/PaidThrough/GetDataBySystemPaymentAccountTypeId/' + 0, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.SystemPaymentAccountTypeId;
            item.label = item.SystemPaymentAccountType;
            delete item.SystemPaymentAccountTypeId;
            delete item.SystemPaymentAccountType;
        });
        SetSystemPaymentArray(json);
    }
    const getCurrenciesAsync = async () => {
        const response = await fetchAPI("api/Currencies/RateCurrency", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        SetCurrencyArray(json);
    }

    useEffect(() => {
        let stateItem: any = {}
       
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(paidThroughInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === true ? true : false;
            setCurrentFieldsData(stateItem);
            setSelectedOptionDropDown({ value: tempObj.SystemPaymentAccountTypeId, label: stateItem.SystemPaymentAccountType });
            setSelectedOptionCurrency({ value: tempObj.AccountCurrencyId, label: stateItem.CurrencyCode });
        }
        else {
            setSelectedOptionDropDown({ value: '', label: '' });
            setSelectedOptionCurrency({ value: '', label: '' });
            setCurrentFieldsData(paidThroughInitialsForAdd);
        }
    }, [selectedRecord])

    useEffect(() => {
        getSystemPaymentAccountTypeAsync();
        getCurrenciesAsync();
    }, [])

   
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updatePaidThroughAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Paid Through Updated Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    
                })
        }
        else {
            dispatch(addPaidThroughAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Paid Through Inserted Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            <Formik
                 initialValues={{
                    ...currentFieldsData,
                    SystemPaymentAccountTypeId: selectedOptionDropDown?.value || "", AccountCurrencyId: selectedOptionCurrecny?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PaidThroughAccountName: yup
                        .string()
                        .label('PaidThroughAccountName')
                        .trim()
                        .required(t('Paid through name is required')),
                        PaidThroughAccountCode: yup
                        .string()
                        .label('PaidThroughAccountCode')
                        .trim()
                        .required(t('Paid through code is required')),
                        SystemPaymentAccountTypeId: yup
                        .string()
                        .required(t('Payment Type is required')),
                        AccountCurrencyId: yup
                        .string()
                        .required(t('Currency is required'))               
                         })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="fs-7 fw-normal">{t('Paid Through Name')}</label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='PaidThroughAccountName' value={values.PaidThroughAccountName} name='PaidThroughAccountName'
                                                    onChange={handleChange('PaidThroughAccountName')}
                                                    onBlur={() => setFieldTouched('PaidThroughAccountName')}
                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.PaidThroughAccountName && errors.PaidThroughAccountName &&
                                                        <p className='errorMsg'>{errors.PaidThroughAccountName as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="fs-7 fw-normal">{t('Paid Through Code')}</label>
                                                <input type="text" className="form-control fs-7 fw-normal" id='PaidThroughAccountCode' value={values.PaidThroughAccountCode} name='PaidThroughAccountCode'
                                                    onChange={handleChange('PaidThroughAccountCode')}
                                                    onBlur={() => setFieldTouched('PaidThroughAccountCode')}
                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.PaidThroughAccountCode && errors.PaidThroughAccountCode &&
                                                        <p className='errorMsg'>{errors.PaidThroughAccountCode as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-6 mb-3">
                                                <label className="fs-7 fw-normal">{t('Payment Type')}</label>
                                                <Select                                                    
                                                    value={values.SystemPaymentAccountTypeId != "" ? SystemPaymentArray.find((option: any) => option.value == values.SystemPaymentAccountTypeId) : ""}
                                                    id="SystemPaymentAccountTypeId"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="SystemPaymentAccountTypeId"
                                                    onBlur={() => setFieldTouched('SystemPaymentAccountTypeId', true)}
                                                    onChange={(selectedOption) => {
                                                        handleChange({
                                                            target: {
                                                                id: "SystemPaymentAccountTypeId",
                                                                value: selectedOption?.value
                                                            },
                                                        });
                                                    }}
                                                    options={SystemPaymentArray}
                                                    styles={colourStyles}

                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.SystemPaymentAccountTypeId && errors.SystemPaymentAccountTypeId &&
                                                        <p className='errorMsg'>{errors.SystemPaymentAccountTypeId as string}</p>
                                                    }
                                                </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="fs-7 fw-normal">{t('Currency')}</label>
                                                <Select                                                   
                                                   value={values.AccountCurrencyId != "" ? currencyArray.find((option: any) => option.value == values.AccountCurrencyId) : ""}
                                                    id="AccountCurrencyId"
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="AccountCurrencyId"
                                                    onBlur={() => setFieldTouched('AccountCurrencyId', true)}
                                                    onChange={(selectedOption) => {
                                                        handleChange({
                                                            target: {
                                                                id: "AccountCurrencyId",
                                                                value: selectedOption?.value
                                                            },
                                                        });
                                                    }}
                                                    options={currencyArray}
                                                    styles={colourStyles}

                                                />
                                                <div style={{ paddingRight: 20 }}>
                                                    {touched.AccountCurrencyId && errors.AccountCurrencyId &&
                                                        <p className='errorMsg'>{errors.AccountCurrencyId as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-lg-12 mb-2" >
                                                <label className="fs-7 fw-normal">{t('Description')}</label>
                                                <textarea
                                                    rows={4} 
                                                    cols={50} 
                                                    placeholder="Enter your text here..."
                                                    id='Description' value={values.Description} 
                                                    className="form-control fs-7 fw-normal"
                                                    onChange={handleChange('Description')}
                                                    onBlur={() => setFieldTouched('Description')}
                                                    
                                                />
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-md-6 mb-2">
                                                {Object.keys(selectedRecord).length > 0 ? (
                                                    <div className="col-md-12">
                                                        <label className="fs-7 fw-normal">{t('Disabled')}</label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input h-20px w-30px" type="checkbox"
                                                                checked={values.IsDisabled} id="IsDisabled"
                                                                onChange={handleChange('IsDisabled')}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack float-end'>
                                    <div className='d-flex align-items-center me-2'>
                                        <button
                                            ref={closeButtonRef}
                                            type="button"
                                            className="btn btn-light btn-sm me-2"
                                            id="kt_OffCanvas"
                                            onClick={handleCloseOnClickEvent}
                                        >
                                            {t('Cancel')}
                                        </button>

                                        <button type="button" data-kt-element='send' className="btn btn-light-primary btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                            {Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default PaidThroughForm